import React, { useState } from 'react';
import { Card, Row, Col } from "react-bootstrap"
import { useTranslation } from 'react-i18next';
import { ActionButton, TooltipHost, TooltipOverflowMode } from "@fluentui/react";
import SidePanelContractInformationBulkUpload from '../../../../components/Products/sPay/PayContractInfo/SidePanelContractInformationBulkUpload';
import { useGetContractByElementId } from '../../../../hooks/services/sKPI/useOfBoard';

const AuxContractInfo = (props) => {
    const { t } = useTranslation();
    const { 
        inputParam_HideHeader = false,
        inputParam_ElementId = null,
    } = props;

    const [isPanelContractInformationOpen, setIsPanelContractInformationOpen] = useState(false);

    const [contract, setContract] = useState(null);

    useGetContractByElementId(inputParam_ElementId, contract, setContract)

    const handlerOpenMoreInformationPanel = () => {
        setIsPanelContractInformationOpen(!isPanelContractInformationOpen)
    }
        
    const renderContent = () => {
        return <>
                    <Row className='py-2 me-1' style={{height: "25%"}}>
                        <Col className='col-auto'>
                            <Row>
                                <Col style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    <Row>
                                        <Col style={{fontSize: "20px", fontWeight: "bolder"}}>{t('data-lang-lbl-contractcode')}</Col>
                                    </Row>
                                    <Row>
                                        <TooltipHost
                                            overflowMode={TooltipOverflowMode.Self}
                                            content={contract.contractCode}
                                        >
                                            <div style={{fontSize: "14px", fontWeight: "normal"}}>{contract.contractCode}</div>
                                        </TooltipHost>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col className='ms-auto'>
                            <Row>
                                <Col style={{fontSize: "20px", fontWeight: "bolder"}}>{t('data-lang-lbl-contractname')}</Col>
                            </Row>
                            <Row>
                                <Col style={{fontSize: "14px", fontWeight: "normal"}}>{contract.name}</Col>
                            </Row>
                        </Col>
                        <Col className='col-auto my-auto'>
                            <Row>
                                <Col className='col-auto me-1' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    <Row>
                                        <Col style={{fontSize: "20px", fontWeight: "bolder"}}>{t('data-lang-lbl-company')}</Col>
                                    </Row>
                                    <Row>
                                        <TooltipHost
                                            overflowMode={TooltipOverflowMode.Self}
                                            content={contract.legalEntityBuyerName}
                                        >
                                            <div style={{fontSize: "14px", fontWeight: "normal"}}>{contract.legalEntityBuyerName}</div>
                                        </TooltipHost>
                                    </Row>
                                </Col>
                                <Col className='col-auto me-1' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    <Row>
                                        <Col style={{fontSize: "20px", fontWeight: "bolder"}}>{t('data-lang-lbl-comlabcompany')}</Col>
                                    </Row>
                                    <Row>
                                        <TooltipHost
                                            overflowMode={TooltipOverflowMode.Self}
                                            content={contract.legalEntitySupplierName}
                                        >
                                            <div style={{fontSize: "14px", fontWeight: "normal"}}>{contract.legalEntitySupplierName}</div>
                                        </TooltipHost>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </>
    }

    return (
            <Card className='board-element-form h-100'>
                {
                    !inputParam_HideHeader &&
                    <Card.Header className="card-header-compact">
                        <Card.Title className="d-flex justify-content-between">
                            <b>{t('data-lang-boxname-contractinformation')}</b>
                            <ActionButton text='Más' onClick={handlerOpenMoreInformationPanel} iconProps={{iconName: "View"}} styles={{ icon: { fontSize: 20 } }} />
                        </Card.Title>
                    </Card.Header>
                }
                <Card.Body className='px-2 pt-2'>
                    {contract && renderContent()}
                </Card.Body>
                {
                    (isPanelContractInformationOpen !== null && contract !== null) &&
                    <SidePanelContractInformationBulkUpload
                        isPanelOpen={ isPanelContractInformationOpen }
                        setterIsPanelOpen={ setIsPanelContractInformationOpen } 
                        contract= { contract }
                    />
                }
            </Card>
    )
};

export default AuxContractInfo;